// extracted by mini-css-extract-plugin
export default {"article":"chXsVkG","padding":"x5a89uW","markdown":"F1p7t4U"};